import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle, XCircle, SpinnerGap } from "@phosphor-icons/react";

export default function PaymentCallback() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState("verifying");
  const reference = params.get("reference") || params.get("trxref");

  useEffect(() => {
    if (!reference) { setState("failed"); return; }
    api.get(`/billing/verify/${reference}`)
      .then(({ data }) => {
        if (data.status === "success") {
          setState("success");
          setTimeout(() => nav("/app/settings?paid=1"), 1800);
        } else setState("failed");
      })
      .catch(() => setState("failed"));
  }, [reference, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center grain p-6">
      <div className="bg-white border border-zinc-200 p-10 text-center max-w-sm w-full vf-fade-up relative z-10">
        {state === "verifying" && (<>
          <SpinnerGap size={48} className="animate-spin mx-auto text-[#1F6FE5] mb-4" />
          <h1 className="font-display font-bold text-xl tracking-tight">Verifying payment…</h1>
          <p className="text-sm text-zinc-500 mt-1">Please wait, do not close this window.</p>
        </>)}
        {state === "success" && (<>
          <CheckCircle size={56} weight="fill" className="mx-auto text-emerald-500 mb-4" />
          <h1 className="font-display font-bold text-2xl tracking-tight">Payment successful</h1>
          <p className="text-sm text-zinc-500 mt-1">Your plan is now active. Redirecting…</p>
        </>)}
        {state === "failed" && (<>
          <XCircle size={56} weight="fill" className="mx-auto text-red-500 mb-4" />
          <h1 className="font-display font-bold text-2xl tracking-tight">Payment not completed</h1>
          <p className="text-sm text-zinc-500 mt-1 mb-6">We couldn't confirm your payment.</p>
          <button data-testid="callback-back" onClick={() => nav("/app/settings")} className="px-4 py-2.5 bg-black text-white rounded-md text-sm font-semibold">Back to billing</button>
        </>)}
      </div>
    </div>
  );
}
